const navDrawerSearch = () => {
  const search = document.querySelector('.nav-search');
  if (!search) return;
  let inputValue = search.querySelector('[data-searchinput]').value;
  const link = search.querySelector('[data-searchbutton]');

  search.querySelector('[data-searchinput]').addEventListener('change', (e) => {
    inputValue = e.target.value;
    inputValue = inputValue.replace(/ /g, '+');
    const searchUrl = `/search?q=${inputValue}`;
    link.href = searchUrl;
  });

  search
    .querySelector('[data-searchinput]')
    .addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        inputValue = e.target.value;
        inputValue = inputValue.replace(/ /g, '+');
        const searchUrl = `/search?q=${inputValue}&type=product`;
        window.location.href = searchUrl;
      }
    });
};

export const header = () => {
  navDrawerSearch();
};
